export default __webpack_public_path__ + "static/media/socialSamosa.85a2e8d3.svg";